import React, { useEffect } from "react";
import { PrimaryButtonStyled } from "../../PrimaryButtonStyled";
import { OutlinedButtonStyled } from "../../OutlinedButtonStyled";
import { useGlobalModal } from "../../../../contexts/GlobalModalContext";
import { TitleFormatter, OrgFormatter } from "../../../adminRoster/AdminPersonnelTable";
import { BestTable } from "best-common-react";
import { useSelectedPersonnel } from "../../../../contexts/SelectedPersonnelContext";
import { DeleteFormatter, NameFormatter, ModalBody, BigsBestTable } from "./BulkCommon";
import { PersonnelTypes } from "../../../../constants/PersonnelTypes";
import axios from "axios";

const Columns = [
    {
        key: "",
        name: "",
        width: 40,
        formatter: DeleteFormatter,
    },
    {
        key: "lastName",
        name: "Name",
        sortable: true,
        formatter: NameFormatter,
        width: 135,
    },
    {
        key: "title",
        name: "Title",
        sortable: true,
        formatter: TitleFormatter,
        width: 110,
    },
    {
        key: "org",
        name: "Club",
        sortable: true,
        formatter: OrgFormatter,
        width: 75,
    },
    {
        key: "affiliateNameLevel",
        name: "Affiliate",
        sortable: true,
        width: 210,
    },
];

type BulkAcceptPersonnelModalBodyProps = {};

const BulkRolloverInProgressModalBody: React.FC<BulkAcceptPersonnelModalBodyProps> = ({}) => {
    const {
        initialSelectedPersonnel,
        selectedPersonnel,
        setSelectedPersonnel,
    } = useSelectedPersonnel();

    useEffect(() => {
        return () => {
            setSelectedPersonnel([...initialSelectedPersonnel]);
        };
    }, []);

    return (
        <ModalBody>
            <span
                style={{
                    fontFamily: "Helvetica",
                    fontStyle: "oblique",
                    color: "#92a5ba",
                    fontSize: "0.875rem",
                }}
            >
                {selectedPersonnel.length} personnel
            </span>
            <BigsBestTable>
                <BestTable
                    data={selectedPersonnel}
                    columns={Columns}
                    headerHeight={30}
                    maxTableHeight={180}
                    rowHeight={40}
                    rowExpansion={{
                        expandable: false,
                    }}
                />
            </BigsBestTable>
        </ModalBody>
    );
};

type BulkRolloverInProgressModalFooterProps = {
    personnelAdvancedSearch(arg1: any, arg2: any, arg3: any, arg4: any, arg5: any): void;
    adminSelectedMenuOptions: Array<any>;
    adminAffiliationFilters: Array<any>;
    adminSearchText: Array<any> | string;
};

const BulkRolloverInProgressModalFooter: React.FC<BulkRolloverInProgressModalFooterProps> = ({
    personnelAdvancedSearch,
    adminSelectedMenuOptions,
    adminAffiliationFilters,
    adminSearchText,
}) => {
    const { closeModal } = useGlobalModal();
    const { selectedPersonnel, bulkRolloverInProgressPersonnel } = useSelectedPersonnel();
    const source = axios.CancelToken.source();
    useEffect(() => {
        return () => {
            source.cancel("Canceling in cleanup");
        };
    }, []);

    return (
        <div className="d-flex">
            <div className="mr-2">
                <PrimaryButtonStyled
                    width={80}
                    height={26}
                    disabled={selectedPersonnel.length === 0}
                    onClick={event => {
                        event.stopPropagation();
                        closeModal();
                        bulkRolloverInProgressPersonnel();
                        setTimeout(
                            () =>
                                personnelAdvancedSearch(
                                    adminSearchText && adminSearchText.length !== 0
                                        ? adminSearchText
                                        : null,
                                    adminAffiliationFilters
                                        ? adminAffiliationFilters.map(opt => opt.orgId)
                                        : null,
                                    adminSelectedMenuOptions.map(opt => opt.id),
                                    PersonnelTypes.CLUB,
                                    source,
                                ),
                            1000,
                        );
                    }}
                >
                    Move
                </PrimaryButtonStyled>
            </div>

            <OutlinedButtonStyled
                width={80}
                height={26}
                onClick={event => {
                    event.stopPropagation();
                    closeModal();
                }}
            >
                Cancel
            </OutlinedButtonStyled>
        </div>
    );
};

BulkRolloverInProgressModalBody.displayName = "BodyContent";
BulkRolloverInProgressModalFooter.displayName = "FooterContent";

export { BulkRolloverInProgressModalBody, BulkRolloverInProgressModalFooter };
